// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-bcdc01f0]{height:100%;margin-bottom:1em}.card-footer>span[data-v-bcdc01f0]:not(:first-child){margin-left:1em}", ""]);
// Exports
module.exports = exports;
